import {AppEntities} from "../../../config/entities";
import {NFLookupCatalogColumn} from "./NFLookupCatalogColumn";
import React from "react";
import {NFLookupDocument} from "./NFLookupDocument";

interface IProps {
    title?: string;
    fieldName: string;
    required?: boolean;
    showBorder?: boolean;
    width?: number;
    selectedCatalog?: boolean;
    setSelectedCatalog?: (value: boolean) => void;
}

export const NFLookupPurchaseOrder = ({
                                          title,
                                          fieldName,
                                          required,
                                          showBorder,
                                          width,
                                          selectedCatalog,
                                          setSelectedCatalog,
                                      }: IProps) => {

    const appEntity = AppEntities.PurchaseOrders;
    const loadData = async (searchText: string | undefined) => {
        return await appEntity.getDataService().GetAll(searchText);
    };

    return (
        <>
            <NFLookupDocument
                fieldName={fieldName}
                title={title}
                entity={appEntity}
                width={width}
                serverData={loadData}
                required={required}
                showBorder={showBorder}
                selectedCatalog={selectedCatalog}
                setSelectedCatalog={setSelectedCatalog}
            >
                {/* <NFLookupCatalogColumn fieldName={"name"} caption={"Name"} /> */}
                <NFLookupCatalogColumn
                    fieldName={"documentNumber"}
                    caption={"documentNumber"}
                />
            </NFLookupDocument>
        </>
    );
};
